import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import Overview from "./pages/Overview";
import Funnel from "./pages/Funnel";
import Uploads from "./pages/Uploads";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import Prompts from "./pages/Prompts";
import Settings from "./pages/Settings";
import MailTemplates from "./pages/MailTemplates";
import Login from "./pages/Login";
import { ConfirmProvider } from "@/components/confirm-dialog";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import "./globals.css";

// Data-Router statt <BrowserRouter>: nur damit useBlocker beim Verlassen
// einer Seite mit ungespeicherten Änderungen warnen kann. Routen unverändert.
const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/orders" replace /> },
      { path: "overview", element: <Overview /> },
      { path: "funnel", element: <Funnel /> },
      // Customers ist in der Übersicht aufgegangen; alte Links landen dort.
      { path: "customers", element: <Navigate to="/overview" replace /> },
      { path: "uploads", element: <Uploads /> },
      { path: "orders", element: <Orders /> },
      { path: "orders/:id", element: <OrderDetail /> },
      { path: "books", element: <Books /> },
      { path: "books/:id", element: <BookDetail /> },
      { path: "prompts", element: <Prompts /> },
      { path: "mail-templates", element: <MailTemplates /> },
      { path: "settings", element: <Settings /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TooltipProvider delayDuration={300}>
      <ConfirmProvider>
        <RouterProvider router={router} />
        <Toaster position="bottom-center" />
      </ConfirmProvider>
    </TooltipProvider>
  </React.StrictMode>,
);
